export default __webpack_public_path__ + "static/media/loading_icon.d3fbaf2b.gif";